import StarFilled from '@alltrails/denali/icons/StarFilled';
import type RatingKey from '@alltrails/types/RatingKey';
import type RatingsBreakdown from '@alltrails/types/RatingsBreakdown';
import styles from './ReviewsGraph.module.scss';

const largestRatingCount = (ratingsBreakdown: RatingsBreakdown): number => {
  const ratings: number[] = Object.keys(ratingsBreakdown).map(Number);
  return ratings.reduce((acc, i) => Math.max(ratingsBreakdown[i], acc), 0);
};

type ReviewsGraphProps = {
  ratingsBreakdown?: RatingsBreakdown;
};

const ReviewsGraph = ({ ratingsBreakdown }: ReviewsGraphProps) => {
  if (!ratingsBreakdown) {
    return null;
  }

  const rows = new Array(5).fill(0).map((_v, i) => {
    const ratingKey = (5 - i).toString() as RatingKey;
    const rating = ratingsBreakdown[ratingKey];
    const barWidth = `${rating ? (rating * 100.0) / largestRatingCount(ratingsBreakdown) : 0}%`;

    return (
      <tr key={`ratings-${ratingKey}`} className={styles.row}>
        <th className={styles.label} scope="row">
          {ratingKey}
        </th>
        <td className={styles.star}>
          <StarFilled size="xs" color="--color-text-primary" />
        </td>
        <td className={styles.graphBar}>
          <div
            data-testid={`graph-bar-${ratingKey}`}
            style={{
              width: barWidth
            }}
          />
        </td>
      </tr>
    );
  });

  return (
    <table className={styles.ratingsTable}>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default ReviewsGraph;
